import { Injectable } from "@angular/core";
import { UserSessionService } from "../user-session/user-session.service";
import { WebservicesService } from "../webservices/webservices.service";
import { CustomerModel } from "src/app/models/customer-model";
import { ConfigService } from "../config/config.service";
import { NotificationEventInterface } from "../notification-api/notification-api.service";

@Injectable({
  providedIn: "root",
})
export class PiggyBankService {
  
 
  public customer: CustomerModel;
  piggyStatus: any;
  constructor(
    private userSession: UserSessionService,
    private webservices: WebservicesService,
    private config: ConfigService
  ) {
    this.getCustomer();
  }
  

  public getCustomer() {
    this.userSession.getCustomerSubscription().then((customerSubscription) => {
      customerSubscription.subscribe((customer) => {
        this.customer = customer;
      });
    });
  }

  getPiggyBankInfo(){
    let obj = {
      customer_id:this.customer.customerId,
      session_token: this.userSession.sessionToken
    }
    return this.webservices.get('bonus/get-piggy-info',obj);
    
  }


  setPiggyStatus(e) {
    this.piggyStatus = e;
  }

  getPiggyStatus(){
    return this.piggyStatus;
  }
}


